module.exports = {
  "debug": {
    "hello": "你好",
    "count": "數是{{count}}",
    "change_lang": "改為{{lang}}",
    "changed": "它變了",
  },

  "meta": {
    "title": "PIGUCHI - 家長設定",
    "description": "PIGUCHI - 存款及貸款的金額，能在家長設定頁面作編輯。",
  },

  "currency": "{{count}}台湾元",
  "message": {
    "confirm_delete": "真的沒問題嗎?",
    "saved": "保存了",
  },
  "header": {
    "done": "完成",
    "save": "保存",
  },
  "index": {
    "title": "家長設定",
    "privacy_policy": "我們已經更新了隱私權政策。請確認。",
    "privacy_policy_link": "https://piguchi.com/privacy_policy/ct/",
    "setting": "的設定",
    "loan_request": "新的貸款申請書",
    "works": "編輯事項清單",
    "amount_account": "編輯帳戶金額",
    "amount_loan": "編輯貸款金額",
    "user": "使用者編輯",
    "add_child": "追加新使用者",
  },
  "works": {
    "title": "編輯事項清單",
    "for_guardians_label": "家長設定",
    "for_guardians_description_1": "App內並無產生任何金錢交易行為。",
    "for_guardians_description_2": "親子間的互動互信下，讓孩子們透過幫忙家務，得到家長給予肯定的「獎勵金」。",
    "todo_list_label": "事項清單",
    "todo_list_description": "決定每天幫忙事項及獎勵金額。",
    "create_new": "追加新事項",
    "once": "1次",
    "edit": "編輯",
    "delete": "刪除",
  },
  "works_single": {
    "title": "編輯事項",
    "icon": "圖示",
    "work_title": "標題",
    "placeholder": "餵狗狗飼料（上限全角30字內）",
    "error_message": "標題輸入為30字以內",
    "reward": "獎勵金額（一次）",
    "change": "變更",
  },
  "user": {
    "title": "使用者編輯",
    "user_name": "使用者姓名",
    "color_label": "更換背景顏色",
    "blue": "淡蓝色",
    "yellow": "黄色",
    "pink": "粉红色",
    "purple": "紫色",
    "green": "翠绿色",
    "delete_user": "刪除使用者",
    "confirm_delete": "真的刪除使用?",
    "error_message": "請輸入為10字以內",
  },
  "image_modal": {
    "title": "選擇圖示",
  },
  "bank_edit": {
    "account_title": "編輯帳戶金額",
    "loan_title": "編輯貸款金額",
    "current_account": "存款餘額",
    "current_loan": "剩餘貸款額",
    "amount_label": "增加/減少的金額",
    "amount_placeholder": "請輸入金額",
    "increase": "增加",
    "decrease": "減少",
    "reason_label": "增加金額/減少金額的理由",
    "reason_placeholder_account": "爺爺給的零用錢",
    "reason_placeholder_loan": "給爺爺的禮物",
    "edit_done": "編輯帳戶金額好了。",
  },
  "loan": {
    "title": "貸款審查",
    "amount": "希望貸款的金額",
    "purpose": "貸款的理由",
    "for_guardians_description_1": "貸款利息為每月貸款總金額的1%，另外加算在剩餘貸款額內。",
    "for_guardians_description_2": "請在充分說明貸款負債的風險後，再受理孩子們的申請。",
    "approve": "受理貸款申請",
    "deny": "駁回貸款申請",
    "approve_message": "貸款審查合格",
    "deny_message": "貸款審查失敗",
  },
};